<template>
  <div
    ref="MainLoading"
    id="global-loader"
    class="fixed inset-0 hidden opacity-0 z-[9999] bg-white bg-opacity-60 flex-col items-center justify-center transition-opacity duration-500 ease-in-out"
  >
    <div class="relative w-20 h-20 mb-4">
      <div
        class="absolute inset-0 border-4 border-brand-blue/20 rounded-full"
      ></div>
      <div
        class="absolute inset-0 border-4 border-brand-blue border-t-transparent rounded-full animate-spin"
      ></div>
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="w-4 h-4 bg-brand-orange rounded-full animate-pulse"></div>
      </div>
    </div>
    <h2
      class="text-xl font-bold text-brand-darkBlue tracking-widest animate-pulse"
    >
      仁曜診所
    </h2>
    <p class="text-sm text-slate-400 mt-2 tracking-wider">載入中...</p>
  </div>
</template>

<script>
export default {
  name: "MainLoading",
  data() {
    return {
      timer: null,
    };
  },
  methods: {
    openDialog() {
      // Show
      this.$refs.MainLoading.classList.remove("hidden");
      this.$refs.MainLoading.classList.add("flex");
      // Animation frame to ensure display:block applies before transition
      requestAnimationFrame(() => {
        this.$refs.MainLoading.classList.remove("opacity-0");
        this.$refs.MainLoading.classList.add("opacity-100");
      });
    },
    closeDialog() {
      this.$refs.MainLoading.classList.remove("opacity-100");
      this.$refs.MainLoading.classList.add("opacity-0");
      setTimeout(() => {
        this.$refs.MainLoading.classList.add("hidden");
        this.$refs.MainLoading.classList.remove("flex");
      }, 300);
    },
  },
  computed: {
    loadingState() {
      return this.$store.state.loading;
    },
  },
  watch: {
    loadingState(newVal) {
      if (newVal) {
        this.openDialog();
      } else {
        this.closeDialog();
      }
    },
  },
};
</script>
